// extracted by mini-css-extract-plugin
export default {"arts":"Arts__arts___g0Lwl","content":"Arts__content___MfuLh","title":"Arts__title___PP_yt","descr":"Arts__descr___Zpbk9","link":"Arts__link___KT3RQ","che":"Arts__che___vUEyy"};